import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/assets";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refresh } = useAuth();
  const [state, setState] = useState("loading");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { setState("error"); return; }
    (async () => {
      try { await api.post("/auth/verify-email", { token }); await refresh(); setState("ok"); }
      catch { setState("error"); }
    })();
  }, [token, refresh]);

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-20 text-center">
      <img src={state === "ok" ? ASSETS.pointing : ASSETS.crying} alt="" className="w-36 mx-auto animate-floaty" />
      <h1 className="headline text-cream text-3xl mt-5">
        {state === "loading" ? "VERIFYING..." : state === "ok" ? <>EMAIL <span className="text-neon">VERIFIED</span></> : <>LINK <span className="text-danger">EXPIRED</span></>}
      </h1>
      <p className="font-mono text-dim text-sm mt-3">
        {state === "loading" ? "Checking if you got robbed..." : state === "ok" ? "You're all set. Go get someone robbed." : "That verification link is invalid or expired."}
      </p>
      <Link to={state === "ok" ? "/dashboard" : "/settings"} className={`btn-neon mt-8 inline-flex ${state === "loading" ? "opacity-0 pointer-events-none" : ""}`} data-testid="verify-cta">
        {state === "ok" ? "Go To Dashboard" : "Back To Settings"}
      </Link>
    </div>
  );
}
